import React from 'react';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {requestDirectory} from '../../actions/directoryActions';
import {Container} from 'reactstrap';
import NodeDetails from './NodeDetails';
import Icon, {ICONS} from '../Icon';

class BrowseNode extends React.Component {
    componentDidMount() {
        if (!this.props.directory) {
            this.props.requestDirectory();
        }
    }

    render() {
        const {directory, match, values} = this.props;
        return (
            <Container>
                <Link to="/browse" className="btn btn-primary"><Icon icon={ICONS.LEVEL_UP} /> Up</Link>
                <h1>
                    <Icon icon={ICONS.NODE} /> {match.params.nodeId}
                </h1>
                {directory && <NodeDetails node={directory.nodes.find(({id}) => id === match.params.nodeId)} values={values} />}
            </Container>
        );
    }
}

const mapStateToProps = (state) => ({
    directory: state.directory.data,
    values: state.property.values,
});

export default connect(mapStateToProps, {requestDirectory})(BrowseNode);
